const initialState = {
  total: -1,
  results: [],
};
const reducerName = 'Bookmarks';
const bookmarksReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'Get'.concat(reducerName):
      return state;
    case 'Insert'.concat(reducerName):
      return {
        results: state.results.concat(
          action.payload.results.filter(
            incoming =>
              state.results.some(current => current.id === incoming.id) ===
              false,
          ),
        ),
        total: action.payload.total ?? state.total,
      };
    case 'Delete'.concat(reducerName):
      return {
        results: state.results.filter(
          bookmark => bookmark.id !== action.payload.id,
        ),
        total: state.total - 1,
      };
    default:
      return state;
  }
};

export default bookmarksReducer;
